import React from 'react';

const CampaignImage = ({ image }) => (
  <div className="campaign-image">
    <img src={image} alt="Campaign" />
  </div>
);

export default CampaignImage;
